export const configuracion = {
    "hash": "3c974163ecd3b540973372efe87ce2afeb267bd2",
    "url": "http://localhost:9006/",
    "etiquetas": {
        "declarativa": {
            "vencimiento": "none",
            "filtro_edad": "no",
            "version_politica_privacidad": "Mapfre España V2",
            "deduplicateWindow": "15d",
            "deduplicateLimit": "316",
            "scoring_IVR": "True",
            "Scoring_priority": "Top",
            "politica": "si",
            "campaña": ""
        },
        "conversion": {
            "c_var_3": "formulario",
            "c_var_4": "test",
            "c_var_1": "No cliente",
            "c_var_5": "No tarificacion"
        },
        "visita": {
            "v_var_2": "test",
            "v_var_7": "no",
            "v_var_12": "Landing-test",
            "v_var_13": "http://localhost:9006/"
        },
        "externas": [
            {
                "id": 1263,
                "option": "1",
                "comments": "Scoring_IVR"
            },
            {
                "id": 1264,
                "option": "4",
                "comments": "Scoring_priority"
            },
            {
                "id": 2189,
                "option": 15,
                "comments": "Comparadores"
            }
        ],
        "venta": {
            "1": "Test"
        }
    },
    "horario": {
        "inicio": "hora_inicio",
        "fin": "hora_fin"
    },
    "dinamizacion": {
        "parametro": "funcion",
        "parametro2": "funcion"
    },
    "parametrizacion": {
        "parametro": "funcion",
        "parametro2": "funcion"
    },
    "gracias": {
        "htmlModalHorario": "Gracias por confiar en MAPFRE",
        "htmlModalFueraHorario": "Estamos fuera de horario"
    }
}